import {BaseFormModel} from './base-form-model';
import {MenuModifier} from './menu-modifier';

export class MenuToppingModifier extends BaseFormModel<MenuToppingModifier> {
    id: number;
    menuModifier: MenuModifier;
    additionalPrice: number;
    sortOrder: number;
    child: boolean;
}
